import { Trans } from '@lyearn/i18n';
import { AddMenuExercise, Exercise } from '@lyearn/icons';
import { addMenuItemType, createReactExtension, PerformanceType } from '@lyearn/lygo-core';

import InlinePlayerToggle from './components/InlinePlayerToggle';

const exerciseExtension = createReactExtension({
  name: 'ly__exercise',
  attrs: {
    exerciseId: {
      default: null,
    },
    inlinePlayer: {
      default: false,
    },
  },
  Component: (props) => {
    const { attrs, ...rest } = props;
    const Component =
      require('@/modules/corporate/modules/course/components/ExerciseCardContainer').default;
    return <Component {...attrs} {...rest} />;
  },
  menuItem: [
    {
      name: 'ly__exercise',
      title: <Trans i18nKey="Common:ResourceType.Exercise" />,
      icon: Exercise,
      addMenuIcon: AddMenuExercise,
      addMenuItemType: addMenuItemType.contents,
      description: <Trans i18nKey="Admin:Contents.ExerciseDescription" />,
      searchWords: ['exercise', 'assessments', 'submission'],
    },
  ],
  advancedMenuItem: {
    name: 'ly__exercise',
    title: 'Exercise Settings',
    components: [
      {
        name: 'inline_player',
        component: InlinePlayerToggle,
        isEnabled: (node) => !!node.attrs.exerciseId,
      },
    ],
  },
  performanceType: PerformanceType.BLOCK_BASED,
});

export default exerciseExtension;
